export default {
  xs: "576px",
  sm: "768px", //768px
  md: "992px", //992px
  lg: "1200px", //1200px
  lgl: "1330px", //1200px
  xl: "1440px" //1440px
};
